import { mountComponents as mount } from "@root/shared/utils/mountComponents";

// shared
import { Icon } from "@root/shared/components/Icon";
import { PopOver } from "@root/shared/components/PopOver";
import { DescriptionStepIndicator } from "@root/shared/components/DescriptionStepIndicator";

// features--publication--pages
import { BrandContentShow } from "@clientFrontend/features/publication/pages/BrandContentShow";
import { ClientContentShow } from "@clientFrontend/features/publication/pages/ClientContentShow";
import { ShopContentShow } from "@clientFrontend/features/publication/pages/ShopContentShow";
import { WorkContentShowStep1 } from "@clientFrontend/features/publication/pages/WorkContentShowStep1";
import { WorkContentShowStep2 } from "@clientFrontend/features/publication/pages/WorkContentShowStep2";
// features--publication--components
import { ClientCommitments } from "@clientFrontend/features/publication/components/ClientCommitments";
import { PrimaryActionWithNotification } from "@clientFrontend/features/publication/components/PrimaryActionWithNotification";
import { ShopNames } from "@clientFrontend/features/publication/components/ShopNames";
import { ShopTableItem } from "@clientFrontend/features/publication/components/ShopTableItem";
import { WorkTableItem } from "@clientFrontend/features/publication/components/WorkTableItem";
import { GuidanceBoxForBelowMinWage } from "@clientFrontend/features/publication/components/GuidanceBoxForBelowMinWage";
import { UserInformationModal } from "@clientFrontend/features/publication/components/UserInformationModal";
import { UserInformationNoteText } from "@clientFrontend/features/publication/components/UserInformationNoteText";
import { SelectedWorkAlbumImage } from "@clientFrontend/features/publication/components/SelectedWorkAlbumImage";
import { SingleImageSelectField } from "@clientFrontend/features/publication/components/SingleImageSelectField";
import { ContactAcquiredButton } from "@clientFrontend/features/publication/components/ContactAcquiredButton";
import { ExpandableGuidanceBox } from "@clientFrontend/features/publication/components/ExpandableGuidanceBox";

// features--scout--pages
import { UserDetailShow } from "@clientFrontend/features/scout/pages/UserDetailShow";
// features--scout--components
import { LoadingModal } from "@clientFrontend/features/scout/components/LoadingModal";
import { UserDetailAndActionButtons } from "@clientFrontend/features/scout/components/UserDetailAndActionButtons";
import { ShowUserDetailModalButton } from "@clientFrontend/features/scout/components/ShowUserDetailModalButton";
import { MultiSelectModal } from "@clientFrontend/features/scout/components/MultiSelectModal";
import { NestedDataMultiSelectModal } from "@clientFrontend/features/scout/components/NestedDataMultiSelectModal";
import { UserCassette } from "@clientFrontend/features/scout/components/UserCassette";
import { ScoutUserCassettes } from "@clientFrontend/features/scout/components/ScoutUserCassettes";
import { ScoutsSavedSearchConditions } from "@clientFrontend/features/scout/components/SavedSearchConditions";
import { ScoutsSavePrevSearchConditionModal } from "@clientFrontend/features/scout/components/ScoutsSavePrevSearchConditionModal";
import { PremiumScoutMessageArea } from "@clientFrontend/features/scout/components/PremiumScoutMessageArea";
import { PcScoutRemainingCountSummary } from "@root/clientFrontend/features/scout/components/PcScoutRemainingCountSummary";
import { PcScoutRemainingCountDetail } from "@root/clientFrontend/features/scout/components/PcScoutRemainingCountDetail";
import { SpScoutRemainingCountDetailWrapperModal } from "@root/clientFrontend/features/scout/components/SpScoutRemainingCountDetailWrapperModal";
import { ScoutTargetAndWorkSelector } from "@clientFrontend/features/scout/components/ScoutTargetAndWorkSelector";
import { WorkIdParamChanger } from "@clientFrontend/features/scout/components/WorkIdParamChanger";
import { OneTimeScoutForm } from "@clientFrontend/features/scout/components/OneTimeScoutForm";
import { RecommendTooltip } from "@clientFrontend/features/scout/components/RecommendTooltip";
import { TotalCountInfoTooltip } from "@root/clientFrontend/features/scout/components/TotalCountInfoTooltip";

// features--entry--components
import { ExtendScreeningDeadlineModal } from "@clientFrontend/features/entry/components/ExtendScreeningDeadlineModal";

// features--awardsEntry--components
import { DivisionDetailModal } from "@clientFrontend/features/awardsEntry/components/DivisionDetailModal";
import { SectionDetailModal } from "@clientFrontend/features/awardsEntry/components/SectionDetailModal";

// features--campaign--components
import { UserPhotoContest } from "@clientFrontend/features/campaign/components/UserPhotoContest";

// features--contract--components
import { EnqueteBeforeSuspenseOrCancellation } from "@clientFrontend/features/contract/components/EnqueteBeforeSuspenseOrCancellation";
import { HoldEnquete } from "@clientFrontend/features/contract/components/HoldEnquete";
import { OnboardingConsultToggleButton } from "@clientFrontend/features/contract/components/OnboardingConsultToggleButton";
import { ReopenEnquete } from "@clientFrontend/features/contract/components/ReopenEnquete";

// features--jobEntry--components
import { JobEntrySearchSelector } from "@clientFrontend/features/jobEntry/components/JobEntrySearchSelector";

// features--support--components
import { GuidanceBoxForInquiry } from "@root/clientFrontend/features/support/components/GuidanceBoxForInquiry";
import { GuidanceBoxForReopenCreate } from "@root/clientFrontend/features/support/components/GuidanceBoxForReopenCreate";
import { GuidanceBoxForReopenUpdate } from "@root/clientFrontend/features/support/components/GuidanceBoxForReopenUpdate";

// components
import { ApplicationErrorNoticeModal } from "@clientFrontend/components/ApplicationErrorNoticeModal";
import { StepChart } from "@clientFrontend/components/StepChart";
import { PromoteLine } from "@clientFrontend/components/PromoteLine";
import { LineAppPromotionModal } from "@clientFrontend/components/LineAppPromotionModal";
import { BonusAvailableInputs } from "@clientFrontend/features/publication/components/BonusAvailableInputs";
import { TransportationInputs } from "@clientFrontend/features/publication/components/TransportationInputs";
import { UniformInputs } from "@clientFrontend/features/publication/components/UniformInputs";

// pages
import { UserDeclineReportIndex } from "@clientFrontend/pages/UserDeclineReportIndex";
import { EntryNotAdopted } from "@clientFrontend/pages/EntryNotAdopted";

// [要リファクタ]以下、mountComponentsを１つにする為、legacyからimportしている
// pages
import { ScoutsSelectLocations } from "@legacy_root/client_frontend/components/pages/scouts/scouts_select_locations";

// projects

// ui_parts
import { SelectWithSearchOption } from "@clientFrontend/features/scout/components/SelectWithSearchOption";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";

// dev環境のみモックサーバーを立ち上げる
import { startMockServerIfDevelopment } from "@root/mocks/startMockServerIfDevelopment";

const components = {
  DescriptionStepIndicator,
  PopOver,
  LoadingModal,
  LazyLoadImage,
  Icon,
  JobEntrySearchSelector,
  UserDetailAndActionButtons,
  ShowUserDetailModalButton,
  MultiSelectModal,
  NestedDataMultiSelectModal,
  ScoutsSavePrevSearchConditionModal,
  ScoutsSavedSearchConditions,
  SelectWithSearchOption,
  ScoutsSelectLocations,
  PremiumScoutMessageArea,
  PcScoutRemainingCountSummary,
  PcScoutRemainingCountDetail,
  SpScoutRemainingCountDetailWrapperModal,
  ScoutTargetAndWorkSelector,
  WorkIdParamChanger,
  OneTimeScoutForm,
  RecommendTooltip,
  TotalCountInfoTooltip,
  WorkContentShowStep1,
  WorkContentShowStep2,
  ShopContentShow,
  BrandContentShow,
  ClientContentShow,
  PrimaryActionWithNotification,
  UserInformationModal,
  UserInformationNoteText,
  ContactAcquiredButton,
  WorkTableItem,
  ShopNames,
  ShopTableItem,
  StepChart,
  ClientCommitments,
  UserCassette,
  UserDetailShow,
  ScoutUserCassettes,
  PromoteLine,
  LineAppPromotionModal,
  UserDeclineReportIndex,
  SelectedWorkAlbumImage,
  SingleImageSelectField,
  EntryNotAdopted,
  ExtendScreeningDeadlineModal,
  UserPhotoContest,
  EnqueteBeforeSuspenseOrCancellation,
  HoldEnquete,
  OnboardingConsultToggleButton,
  ReopenEnquete,
  DivisionDetailModal,
  SectionDetailModal,
  GuidanceBoxForInquiry,
  GuidanceBoxForReopenCreate,
  GuidanceBoxForReopenUpdate,
  GuidanceBoxForBelowMinWage,
  ApplicationErrorNoticeModal,
};

startMockServerIfDevelopment();

export const mountComponents = (): void => {
  mount(components);
};

// 下記求人タグ関連のreactコンポーネントを表示したい対象画面では、イベントリスナーをDOMContentLoadedのタイミングで発火させることができないため
// アセットパイプライン側のJSでajaxの読み込みが完了したらカスタムイベント発火させて、packs側ではカスタムイベントの発火後にmountComponentsするようにしている
export const mountInputs = (): void => {
  mount({
    StepChart,
    ExpandableGuidanceBox,
    BonusAvailableInputs,
    TransportationInputs,
    UniformInputs,
    // mountComponents は data-react-class を持つ DOM 全要素を走査し、
    // 引数のマップに未登録のコンポーネントがあると throw して以降の mount が止まるため、
    // 親ページにマウント済みの data-react-class も含める必要がある
    ApplicationErrorNoticeModal,
  });
};

mountComponents();

document.addEventListener("ajaxComplete", () => {
  mountInputs();
});

// SP画面のモーダルがAjaxで読み込まれた後にReactコンポーネントを再マウント
// app/assets/javascripts/client_frontend/sp/application.js の 35行目で .modal-content の中身が変更される
// MutationObserverでDOM変更を監視してReactコンポーネントを再マウント
document.addEventListener("DOMContentLoaded", () => {
  const modalContent = document.querySelector(".modal-content");
  if (modalContent) {
    const observer = new MutationObserver(() => {
      // js-entries_filter_modal-content が存在する場合のみReactコンポーネントを再マウント
      const entriesFilterModalContent = document.getElementById("js-entries_filter_modal-content");
      if (entriesFilterModalContent) {
        mountComponents();
      }
    });

    observer.observe(modalContent, {
      childList: true,
      subtree: true,
    });
  }
});
